import { action, observable, runInAction } from 'mobx';
import _ from 'lodash';
import { dispatch } from 'rfx-core';

import { CompanyFormInstance, init as initForm } from '#/shared/forms/company';
import { getChildLogger } from '#/shared/utils/client.logger';

export default class CompanyEditModal {
  log = getChildLogger('ui.CompanyEditModals');

  @observable
  isOpen = false;

  @observable
  company = {};

  @observable
  owner = {};

  @observable
  parent = {};

  @observable
  form: CompanyFormInstance;

  @action.bound
  async setup({
    company = {},
    parent,
    open = this.isOpen,
    owner = company.owner,
    /** Whether to redirect to the company details page after saving. By default, only true for new companies */
    redirect = !company?.uuid,
    afterFinish,
  }) {
    this.company = company;

    const parentIDorObj =
      parent || (company.path || '').split('/').slice(0, -1).pop();

    await Promise.all([this.setParent(parentIDorObj), this.setOwner(owner)]);

    runInAction(() => {
      this.form = initForm(this.company);
      this.form.setShouldRedirect(redirect);
      this.form.setAfterFinish(afterFinish);

      this.isOpen = open;
    });
  }

  @action
  open(arg = !this.isOpen) {
    this.isOpen = !!arg;
  }

  @action
  async setOwner(user) {
    const owner =
      _.isString(user) && !_.isEmpty(user)
        ? await dispatch('users.get', user, { select: false })
        : user;

    runInAction(() => {
      this.owner = owner || {};
    });
  }

  @action
  async setParent(company) {
    const parent =
      _.isString(company) && !_.isEmpty(company)
        ? await dispatch('companies.get', company, { select: false })
        : company;

    runInAction(() => {
      this.parent = parent || {};
    });
  }

  @action
  createCompany() {
    this.form.submit();
  }

  @action
  setCompany(company) {
    this.company = company;
  }

  @action
  clear() {
    this.isOpen = false;

    this.company = {};
    this.parent = {};
    this.owner = {};

    this.form?.clear?.();
    this.form = null;
  }
}
